// extracted by mini-css-extract-plugin
export default {"job-benefits":"JobBenefits_job-benefits__SvgMB","benefits-list":"JobBenefits_benefits-list__38og1","benefit":"JobBenefits_benefit__yxIK8","icon":"JobBenefits_icon__yBgbT"};